import api from "./api";

// Fields that are arrays of objects and must be sent as a single JSON string
// because the backend uses parseIfJson() on them (not indexed bracket notation)
const JSON_ARRAY_FIELDS = [
  "additionalLicenses",
  "additionalSchools",
  "selectedCourses",
  "socialMedia",
  "facilities",
  "ageGroups",
  "accreditations",
  "openingHours",
  "classSchedules",
  "branches",
  "upcomingProgrammes",
];

export const updateUserProfile = async (data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    const value = data[key];

    // Skip undefined or null values
    if (value === undefined || value === null) return;

    // Handle Files (picture or single file fields)
    if (value instanceof File || value instanceof Blob) {
      formData.append(key, value);
      return;
    }

    // Handle document/photo file arrays (e.g. documents: [File, File])
    // Sent as repeated keys so multer picks them up as req.files.<key>[]
    if ((key === "documents" || key === "photos") && Array.isArray(value)) {
      value.forEach((file) => {
        if (file instanceof File || file instanceof Blob) {
          formData.append(key, file);
        }
      });
      return;
    }

    // Arrays of objects that the backend parses with parseIfJson()
    // Must be sent as a single JSON string, NOT as indexed bracket keys
    if (Array.isArray(value) && JSON_ARRAY_FIELDS.includes(key)) {
      formData.append(key, JSON.stringify(value));
      return;
    }

    // Plain objects (location, mainProgram, etc.)
    if (typeof value === "object" && !Array.isArray(value)) {
      formData.append(key, JSON.stringify(value));
      return;
    }

    // Other arrays (primitive values) — indexed bracket notation
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        formData.append(
          `${key}[${index}]`,
          typeof item === "object" ? JSON.stringify(item) : item,
        );
      });
      return;
    }

    // Primitive values (strings, numbers, booleans)
    formData.append(key, value);
  });

  const response = await api.put("/users/me", formData);
  return response.data;
};
